<template>
  <div class="bg-white shadow-md mt-10 p-6">
    <h1 class="text-3xl font-bold text-center mt-10">{{ __('Reports') }}</h1>

    <div class="my-10 flex justify-center flex-wrap">

      <div class="my-5 mx-10 flex flex-col items-center relative">
        <div class="bg-coral-400 w-24 h-24 flex items-center justify-center p-5">
          <icon name="list" class="text-white fill-current h-full w-full"></icon>
        </div>
        <div class="text-center mt-4 text-lg font-bold">
          {{ __('Jobs overview') }}
        </div>
        <inertia-link :href="route('jobReports.createOverview')" class="absolute h-full w-full"></inertia-link>
      </div>


      <div class="my-5 mx-10 flex flex-col items-center relative">
        <div class="bg-coral-400 w-24 h-24 flex items-center justify-center p-5">
          <icon name="list" class="text-white fill-current h-full w-full"></icon>
        </div>
        <div class="text-center mt-4 text-lg font-bold">
          {{ __('Jobs') }}
        </div>
        <inertia-link :href="route('jobReports.create')" class="absolute h-full w-full"></inertia-link>
      </div>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import Icon from '@/Shared/Icon';

export default {
  layout: Layout,
  props: {
    auth: Object,
  },
  metaInfo() {
    return {
      title: this.__('Reports'),
    };
  },
  components: {
    Layout,
    Icon,
  },
};
</script>
